import { createReducer } from '@reduxjs/toolkit';
import Logger, { LoggingModule } from 'services/Logger';
import { Nullable } from 'modules/types/common';
import { MobileSettings, SharedSettings } from './types';
import * as actions from './actions';

export type AppSettingsState = Readonly<{
  loaded: boolean;
  isFetching: boolean;
  mobile: MobileSettings;
  shared: SharedSettings;
  error?: Nullable<Error>;
}>;

export const appSettingsInitialState: AppSettingsState = {
  loaded: false,
  isFetching: false,
  mobile: {
    AmWell_SDK_Key: '',
    app_support: {
      bundle_identifier: '',
      ios_minimum_support_version: '',
      app_store_url: '',
      ios_current_version: '',
      android_minimum_support_version: '',
      play_store_url: '',
      android_current_version: '',
      release_notes: ''
    }
  },
  shared: {
    errors: {},
    apikey: '',
    encryption_algorithm: '',
    encryption_password: '',
    amwell: {
      encryption_password: ''
    },
    billing: {
      encryption_algorithm: '',
      encryption_iv: '',
      encryption_password: ''
    },
    evisit: { sla: [] }
  }
};

const appSettingsReducer = createReducer(appSettingsInitialState, {
  [actions.GET_APP_SETTINGS]: (state, action) => {
    return { ...state, ...action.payload.data, isFetching: true };
  },
  [actions.GET_APP_SETTINGS_SUCCESS]: (state, action) => {
    return { ...state, ...action.payload.data, loaded: true, error: null, isFetching: false };
  },
  [actions.GET_APP_SETTINGS_FAIL]: (state, action) => {
    Logger.error(`${LoggingModule.splash} Failed to fetch app settings`);
    return { ...state, error: action.error, isFetching: false };
  }
});

export default appSettingsReducer;
